import { Component, Vue } from 'vue-property-decorator'
import { ICodesForHeader } from '~/types/api/TechRehab'
import ArrowSvg from '~/assets/svg/link-arrow.svg?inline'
import ECertificateLogo from '~/assets/svg/e-certificate-logo.svg?inline'
import s from '~/utils/s'
import { ECERTIFICATE_CONSTANTS } from '~/types/enum/ECertificate'

@Component
export default class ECertificate extends Vue {
  showCodes = false
  search : string = ''
  selectedText: string = '';
  codes: ICodesForHeader[] = []
  selectedCode: ICodesForHeader = {
    code: '',
    name: ''
  }

  mounted () {
    this.codes.push({ code: ECERTIFICATE_CONSTANTS.defaultCode, name: '' })
    if (s(this.$store).categoryPage.codesForHeader) {
      s(this.$store).categoryPage.codesForHeader.map((currentCode) => {
        this.codes.push(currentCode)
      })
    }
  }

  updateCodes () {
    this.codes = []
    this.codes.push({ code: ECERTIFICATE_CONSTANTS.defaultCode, name: '' })
    s(this.$store).categoryPage.codesForHeader.map((currentCode) => {
      this.codes.push(currentCode)
    })
  }

  searchCertificate (v: InputEvent) {
    this.showCodes = true
    if (v.inputType === ECERTIFICATE_CONSTANTS.insertInput) {
      this.search += v.data
    } else {
      this.search = this.search.slice(0, this.search.length - 1)
    }

    this.updateCodes()
    const searchedCodes = this.codes.map((item) => {
      if (item.code.includes(this.search)) { return item } else { return null }
    })
    this.codes = searchedCodes.filter(item => item !== null) as ICodesForHeader[]
  }

  selectFilter (e: any) {
    e.preventDefault()
    if (this.selectedCode) {
      this.selectItemFromSearch()
    }
    if (this.selectedCode) {
      if (this.selectedCode.code === ECERTIFICATE_CONSTANTS.defaultCode || this.search === '' || this.selectedCode.code === '') {
        s(this.$store).categoryFilter.clearFilter()
      } else {
        s(this.$store).categoryFilter.setSelectedFilter({ code: [this.selectedCode.code] })
      }
    } else {
      s(this.$store).categoryFilter.clearFilter()
    }
  }

  selectItemFromSearch () {
    this.showCodes = false
    this.updateCodes()
    const searchedCodes = this.codes.map((item) => {
      if (item.code === this.search) { return item } else { return null }
    })

    if (searchedCodes) {
      this.selectedCode = searchedCodes.filter(item => item !== null)[0]!
        ? searchedCodes.filter(item => item !== null)[0]!
        : {
          code: '',
          name: ''
        }
    } else {
      this.selectedCode = {
        code: '',
        name: ''
      }
    }
  }

  render () {
    return (
      <div class="catalog-page__e-certificate-background">
        <div class="catalog-page__e-certificate-wrapper">
          <div class ="catalog-page__e-certificate-header">
            <div class ="catalog-page__e-certificate-image">
              <ECertificateLogo/>
            </div>
            <div class ="catalog-page__e-certificate-info">
              <h2 class ="catalog-page__e-certificate-info-title">
                  Электронный сертификат
              </h2>
              <div class ="catalog-page__e-certificate-text">
                  Для того чтобы воспользоваться своим электронным сертификатом - выберите код изделия (в соответствии с указанным в вашей индивидуальной программе реабилитации и абилитации)
              </div>
            </div>
          </div>
          <form class="catalog-page__e-certificate-search" onsubmit={this.selectFilter}>
            <div class="catalog-page__e-certificate">
              <label for="certificate-field" class="catalog-page__e-certificate-input-name">Код изделия</label>
              <input
                value={this.search}
                placeholder={ECERTIFICATE_CONSTANTS.defaultCode}
                id="certificate-field"
                {...{
                  class: {
                    'catalog-page__e-certificate-input': true,
                    'catalog-page__e-certificate-input-active': this.showCodes
                  },
                  on: {
                    input: (v: InputEvent) => {
                      this.searchCertificate(v)
                    },
                    click: (event: MouseEvent) => {
                      event.stopPropagation()
                      this.showCodes = true
                    }
                  },
                  directives: [{
                    name: 'VueClickOutside',
                    value: () => this.showCodes = false
                  }]
                }} />
              <div {...{
                class: {
                  'catalog-page__e-certificate-filters': true,
                  'catalog-page__e-certificate-filters-active': this.showCodes
                }
              }}>
                <div class="catalog-page__e-certificate-items">
                  {this.codes.map(code => (
                    <div
                      {...{
                        class: 'catalog-page__e-certificate-item',
                        on: {
                          click: (event: MouseEvent) => {
                            event.stopPropagation()
                            this.showCodes = false
                            this.search = code.code
                            this.selectedCode = code
                          }
                        }
                      }}
                    >
                      <div class="catalog-page__e-certificate-item-text">
                        {`${code.code} ${code.name}`}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                {...{
                  class: {
                    'catalog-page__e-certificate-arrow': true,
                    'catalog-page__e-certificate-arrow-active': this.showCodes
                  },
                  on: {
                    click: (event: MouseEvent) => {
                      event.stopPropagation()
                      this.showCodes = !this.showCodes
                    }
                  }
                }}>
                <ArrowSvg />
              </div>
            </div>
            <input class="button-text e-certificate" type="submit" value="Применить"/>
          </form>
        </div>
      </div>
    )
  }
}
